module.exports = __webpack_public_path__ + "static/media/coopons_w_logo.25e7ebcd.png";